import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEditPdf24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#1BCFC4" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.333 7.833c0-.776 0-1.165.127-1.47.17-.41.494-.734.902-.903.306-.127.695-.127 1.471-.127h8.334c.776 0 1.164 0 1.47.127.41.17.734.494.903.902.127.306.127.695.127 1.471m-10 10.834h6.666M10.542 5.333v13.334m2.916-13.334v13.334"
    />
  </svg>
);
export default SvgEditPdf24;
